"use client"

import Image from "next/image"
import Link from "next/link"
import { motion } from "framer-motion"
import { useLocale } from "@/context/LocaleContext"
import { slideVariants, staggerContainerVariants, staggerItemVariants } from "@/utils/animation";


export default function NewFeature() {
  const { t } = useLocale();

  return (
    <>
      {/* Header block */}
      <section className="bg-white px-6 pt-20 pb-[30px] text-center">
        <motion.h2
          variants={slideVariants(false, 0.6)}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          className="font-[Poppins,sans-serif] font-semibold text-[28px] md:text-[36px] mb-3 text-[#2E2E38]"
        >
          {t("LandingPage.new_feature_title") || "Semua Fitur Undangan Digital Dalam Satu Platform"}
        </motion.h2>
        <motion.p
          variants={slideVariants(false, 0.6)}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          transition={{ delay: 0.1 }}
          className="text-[15px] md:text-[17px] text-[#6B6B76] m-0"
        >
          {t("LandingPage.new_feature_subtitle") || "Fitur lengkap, bisa disebar unlimited, dan tanpa masa aktif."}
        </motion.p>
      </section>

      {/* Content block */}
      <section className="bg-white px-6 pt-10 pb-[60px] md:pb-[100px]">
        <div className="max-w-[1120px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-[70px] items-center">

          {/* Image */}
          <motion.div
            variants={slideVariants(true, 0.6)}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            className="relative order-1 lg:order-none h-full w-full rounded-[22px] overflow-hidden flex items-center justify-center"
          >
            <Image
              src="/images/cta/mockup-feature.webp"
              alt={t("LandingPage.new_feature_img_alt") || "Fitur All-in-One Elynk.co"}
              fill
              className="object-contain object-bottom scale-[1.05]"
              sizes="(max-width: 768px) 100vw, 40vw"
            />
          </motion.div>

          {/* Text content */}
          <motion.div
            variants={slideVariants(false, 0.6)}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            className="order-2 lg:order-none flex flex-col"
          >
            <h3 className="font-[Poppins,sans-serif] font-semibold text-[24px] md:text-[30px] mb-5 text-[#2E2E38] leading-tight">
              {t("LandingPage.new_feature_heading_1") || "All-in-One Undangan Digital"}{" "}
              {t("LandingPage.new_feature_heading_2") || "Platform (GRATIS)"}
            </h3>

            <p className="text-[15px] md:text-[16px] text-[#6B6B76] leading-[1.7] mb-6">
              {t("LandingPage.new_feature_desc_1") || "Semua fitur dasar undangan digital tersedia lengkap di Elynk.co. Fitur lengkap, bisa disebar unlimited, dan "}
              <strong className="text-[#2E2E38] font-bold">
                {t("LandingPage.new_feature_desc_bold")}
              </strong>.
            </p>

            <p className="font-[Poppins,sans-serif] font-semibold text-[15px] md:text-[16px] mb-4 text-[#2E2E38]">
              {t("LandingPage.new_feature_list_title") || "Fitur Undangan yang Kamu Dapatkan:"}
            </p>

            <motion.ul
              variants={staggerContainerVariants(0.08)}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              className="m-0 pl-5 text-[#4A4A55] text-[15px] md:text-[16px] leading-[2.1] list-disc"
            >
              {[
                t("LandingPage.new_feature_list_1"),
                t("LandingPage.new_feature_list_2"),
                t("LandingPage.new_feature_list_3"),
                t("LandingPage.new_feature_list_4"),
                t("LandingPage.new_feature_list_5"),
                t("LandingPage.new_feature_list_6"),
              ].map((item, i) => (
                <motion.li key={i} variants={staggerItemVariants(0.5)}>
                  {item}
                </motion.li>
              ))}
            </motion.ul>

            <motion.div
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ delay: 0.15, duration: 0.4, ease: "easeOut" }}
              className="mt-[26px]"
            >
              <Link
                href="/features/all-in-one-invitation"
                className="inline-flex items-center justify-center bg-[#E9EBEF] hover:bg-[#D4D4D4] text-[#2E2E38] font-[Poppins,sans-serif] font-semibold text-[14px] md:text-[15px] py-3.5 px-[26px] rounded-xl transition-transform duration-200 hover:scale-[1.04] w-full sm:w-auto"
              >
                {t("LandingPage.new_feature_btn") || "Lihat selengkapnya"}
              </Link>
            </motion.div>
          </motion.div>

        </div>
      </section>
    </>
  )
}